<template>
    <div
        :class="[
            'web-news-stock-news-list',
            {
                isPC: !isH5
            }
        ]"
    >
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="loading" class="loading">
            <img src="../images/loading.png" alt="loading..." />
        </div>
        <div v-else-if="showContent" key="showContent" class="content-wrapper">
            <div class="web-news-stock-news-list-content">
                <a
                    v-for="(item, index) in showCountList"
                    :key="index"
                    class="item"
                    href="javascript:;"
                    @click="onClickItem(item)"
                >
                    <div class="title-source">
                        <div class="title" :style="{ color: titleColor }">{{ item.buffTitle }}</div>
                        <div class="source" :style="{ color: sourceColor }">
                            {{ item.source }}&nbsp;&nbsp;{{ formatTime(item.dwTime) }}
                        </div>
                    </div>
                    <div class="img-wrapper">
                        <img :src="item.pic" />
                    </div>
                </a>
            </div>
            <div class="btn" v-if="showBtn">
                <a
                    :class="[
                        'more-text',
                        {
                            isMoo: isMoo
                        }
                    ]"
                    :style="{
                        '--more-color': moreColor
                    }"
                    href="javascript:;"
                    @click="onClickMore"
                >
                    {{ moreText }}
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.25 2L9.75 9.5L2.25 17"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
const {
    common: {
        request: { bindCommonApi },
        behavior: { runBehaviour }
    }
} = require('@futuweb/fego-render');

import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
const commonApiRequest = bindCommonApi('web-news-stock-news-list');
import { isH5, getIsPreRender, isMoo, getEntity } from '../utils';
import { LANG_NUM_MAP } from '../constants/i18n';

const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
});

export default {
    name: 'web-news-stock-news-list',
    props: {
        language: {
            type: String,
            default: 'en-us'
        },
        titleColor: {
            type: String,
            default: '#262626'
        },
        sourceColor: {
            type: String,
            default: '#7a7a7a'
        },
        // 展示条数
        showCount: {
            type: Number,
            default: 3
        },
        // 查看更多
        moreText: {
            type: String,
            default: 'More'
        },
        moreColor: {
            type: String,
            default: '#327FFF'
        },
        needLogin: {
            type: Boolean,
            default: true
        },
        showBtn: {
            type: Boolean,
            default: true
        },
        stockId: {
            type: String
        },
        stockCode: {
            type: String
        }
    },
    data() {
        return {
            loading: false,
            isH5: isH5(),
            isPreRender: getIsPreRender(),
            list: [],
            isMoo: isMoo()
        };
    },
    computed: {
        showContent() {
            return !this.loading && this.list && this.list.length;
        },
        showCountList() {
            return this.list.slice(0, this.showCount);
        }
    },
    async mounted() {
        if (this.isPreRender) {
            return;
        }
        this.loading = true;

        try {
            const data = await commonApiRequest.get(
                'list',
                {
                    lang: LANG_NUM_MAP[this.language],
                    size: this.showCount,
                    stockId: this.stockId
                },
                {
                    group: null
                }
            );
            this.list = data && data.news;
        } catch (error) {
            this.list = []; // 不展示
        }

        this.loading = false;
    },
    methods: {
        formatTime(time) {
            return toolDateFormatter.dateFormatByTemplate({
                dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
                timestamps: time * 1e3,
                lang: LANG_NUM_MAP[this.language]
            });
        },
        onClickItem(item) {
            const url = item.buffUrl;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        },
        onClickMore() {
            const url = this.isMoo
                ? `https://www.moomoo.com/stock/${this.stockCode}/news?lang=${this.language}`
                : `https://www.futunn.com/stock/${this.stockCode}/news?lang=${this.language}`;
            if (this.needLogin) {
                return runBehaviour(this, {
                    type: 'login',
                    value: url,
                    lang: this.language,
                    withQuery: true
                });
            }
            return (location.href = url);
        }
    }
};
</script>
<style lang="less" scoped>
.web-news-stock-news-list {
    height: auto !important;
    font-family: brRegular, 'FZLanTingHei-R-GBK', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
        'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'ヒラギノ角ゴ Pro W3',
        'Hiragino Kaku Gothic Pro', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic';
    &.ja {
        font-family: brRegular, 'SourceHanSansJP-Regular', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', Meiryo,
            'ＭＳ Ｐゴシック', 'MS PGothic', 'BR Hendrix', 'PingFang SC', 'PingFang HK', -apple-system,
            'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        .web-news-stock-news-list-content {
            .item {
                .title-source {
                    .title {
                        font-family: brSemiBold, 'SourceHanSansJP-Bold';
                    }
                }
            }
        }
    }
    .web-news-stock-news-list-content {
        padding: 0 0.4rem;
        .item {
            display: flex;
            align-items: center;
            padding: 0.3rem 0;
            position: relative;
            a {
                position: absolute;
                display: block;
                width: 100%;
                height: 100%;
            }
            &:first-child {
                padding-top: 0;
            }
            &:last-child {
                padding-bottom: 0;
            }
            &:not(:last-child) {
                border-bottom: 1px solid #e5e5e5;
            }
            .title-source {
                flex: 1;
                min-width: 0;
                margin-right: 0.3rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 1.4rem;
                .title {
                    font-size: 0.3rem;
                    line-height: 1.5;
                    // 限制两行
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
                .source {
                    font-size: 0.22rem;
                }
            }
            .img-wrapper {
                width: 1.8rem;
                height: 1.4rem;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                    border-radius: 0.06rem;
                }
            }
        }
    }
    .content-wrapper {
        position: relative;
        .btn {
            display: flex;
            justify-content: center;
            margin-top: 0.3rem;
            .more-text {
                font-size: 0.3rem;
                line-height: 0.3rem;
                color: var(--more-color);
                display: flex;
                align-items: center;
                svg {
                    margin-left: 0.12rem;
                    width: 0.15rem;
                    height: 0.26rem;
                    path {
                        stroke: var(--more-color);
                    }
                }
            }
        }
    }
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
        @keyframes rotate {
            0% {
                transform: rotate(0);
            }
            100% {
                transform: rotate(360deg);
            }
        }
        img {
            width: 0.56rem;
            height: 0.56rem;
            background: url('../images/loading.png') center / contain no-repeat;
            animation: rotate 2s linear infinite;
        }
    }
}
.web-news-stock-news-list.isPC {
    .content-wrapper {
        margin: auto;
        .btn {
            .more-text {
                font-size: 0.22rem;
            }
        }
    }
    .web-news-stock-news-list-content {
        padding: 0 0 0.4rem;
        .item {
            cursor: pointer;
            .title-source {
                height: 1.6rem;
                margin-right: 0.4rem;
                .title {
                    font-size: 0.22rem;
                }
                .source {
                    font-size: 0.16rem;
                }
            }
            .img-wrapper {
                width: 2.4rem;
                height: 1.6rem;
            }
        }
    }
    .loading {
        height: 3rem;
    }
}
</style>
